import { h } from 'preact'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  onClick: (e: MouseEvent) => void
  className?: string
  displayLikeCount?: boolean
  likeCount?: number
}

const TopicLike = ({ onClick, className, displayLikeCount, likeCount = 0 }: Props) => {
  return (
    <li className={`post__action-item post-footer-item text--meta ${className ?? ''}`} onClick={(e: MouseEvent) => onClick(e)}>
      <Icon size={16} icon='like' />
      {
        displayLikeCount
          ? (
            <span> {likeCount} </span>
            )
          : (
            <span className='post-footer-item-text'>
              <Phrase m='Common' p='like' />
            </span>
            )
      }
    </li>
  )
}

export default TopicLike
